<template>
    <div class="block">
<!--        //TODO need refactoring-->
        <RowBlockBonusSystem :item="item" v-if="item.typeId === 3"></RowBlockBonusSystem>
        <RowBlockWithdrawalOfFunds :item="item" v-if="item.subtype === accountCashHistoryInfo.subtype.withdrawal_of_funds"></RowBlockWithdrawalOfFunds>

        <RowBlockPaymentPenalty :item="item" v-else-if="isPaymentPenalty(item)"></RowBlockPaymentPenalty>

        <RowBlockBuyingInsurance v-else-if="showBlockBuyingInsurance(item)" :item="item" ></RowBlockBuyingInsurance>
        <WritingOffComissionEarlyPolicyTermination v-else-if="showBlockWritingOffComissionEarlyPolicyTermination(item)" :item="item" ></WritingOffComissionEarlyPolicyTermination>
        <WritingOffExcessComissionEarlyPolicyTermination v-else-if="showBlockWritingOffExcessComissionEarlyPolicyTermination(item)" :item="item" ></WritingOffExcessComissionEarlyPolicyTermination>
        <RefundOffComissionEarlyPolicyTermination v-else-if="showBlockRefundOffComissionEarlyPolicyTermination(item)" :item="item" ></RefundOffComissionEarlyPolicyTermination>
        <RefundOfExcessComissionEarlyPolicyTermination v-else-if="showBlockRefundOfExcessComissionEarlyPolicyTermination(item)" :item="item" ></RefundOfExcessComissionEarlyPolicyTermination>
        <RowBlockBuyingGreenCardInsurance v-else-if="showBlockBuyingGreenCardInsurance(item)" :item="item" ></RowBlockBuyingGreenCardInsurance>
        <RowBlockBuyingAccidentInsurance v-else-if="showBlockBuyingAccidentInsurance(item)" :item="item" ></RowBlockBuyingAccidentInsurance>
        <RowBlockBuyingManualInsurance v-else-if="showBlockBuyingManualInsurance(item)" :item="item" ></RowBlockBuyingManualInsurance>
        <RowBlockBuyingTourismInsurance v-else-if="showBlockBuyingTourismInsurance(item)" :item="item" ></RowBlockBuyingTourismInsurance>
        <RowBlockBuyingHomeInsurance v-else-if="showBlockBuyingHomeInsurance(item)" :item="item" ></RowBlockBuyingHomeInsurance>
        <RowBlockBuyingPetsInsurance v-else-if="showBlockBuyingPetsInsurance(item)" :item="item" ></RowBlockBuyingPetsInsurance>
        <RowBlockInsuranceCommission v-else-if="showBlockInsuranceCommission(item)" :item="item" ></RowBlockInsuranceCommission>
        <RowBlockReferralInsuranceCommission v-else-if="showBlockReferralInsuranceCommission(item)" :item="item" ></RowBlockReferralInsuranceCommission>
        <RowBlockInvoiceForClient v-else-if="showBlockInvoiceForClient(item)" :item="item" ></RowBlockInvoiceForClient>
        <RowBlockInvoiceForPartnerByAdmin v-else-if="showBlockInvoiceForPartnerByAdmin(item)" :item="item"></RowBlockInvoiceForPartnerByAdmin>
        <RowBlockPaymentInsuranceThroughInvoicing v-else-if="showBlockPaymentInsuranceThroughInvoicing(item)" :item="item" ></RowBlockPaymentInsuranceThroughInvoicing>
        <RowBlockPaymentInsuranceByLegalEntity v-else-if="showBlockPaymentInsuranceByLegalEntity(item)" :item="item" ></RowBlockPaymentInsuranceByLegalEntity>
        <RowBlockPaymentMonobankPayParts v-else-if="showBlockMonobankPayParts(item)" :item="item" ></RowBlockPaymentMonobankPayParts>
        <RowBlockInvoiceForClientByAdmin v-else-if="showBlockInvoiceForClientByAdmin(item)" :item="item" ></RowBlockInvoiceForClientByAdmin>
        <RowBlockWithdrawInvoiceForClientByAdmin v-else-if="showBlockWithdrawInvoiceForClientByAdmin(item)" :item="item" ></RowBlockWithdrawInvoiceForClientByAdmin>
        <RowBlockWithdrawInvoiceForPartnerByAdmin v-else-if="showBlockWithdrawInvoiceForPartnerByAdmin(item)" :item="item" ></RowBlockWithdrawInvoiceForPartnerByAdmin>
        <RowBlockWithdrawInvoiceForPartnerByMainUser v-else-if="showBlockWithdrawInvoiceForPartnerByMainUser(item)" :item="item" ></RowBlockWithdrawInvoiceForPartnerByMainUser>
        <RowBlockRefundFundsCanceledContract v-else-if="showBlockRefundFundsCanceledContract(item)" :item="item" ></RowBlockRefundFundsCanceledContract>
        <RowBlockWritingOffCommissionDgo v-else-if="showRowBlockWritingOffCommissionDgo(item)" :item="item" ></RowBlockWritingOffCommissionDgo>
        <RowBlockWritingOffCommissionAutolawyer v-else-if="showRowBlockWritingOffCommissionAutolawyer(item)" :item="item" ></RowBlockWritingOffCommissionAutolawyer>
        <RowBlockWritingOffCommissionOsago v-else-if="showRowBlockWritingOffCommissionOsago(item)" :item="item" ></RowBlockWritingOffCommissionOsago>
        <RowBlockWritingOffCommissionManual v-else-if="showRowBlockWritingOffCommissionManual(item)" :item="item" ></RowBlockWritingOffCommissionManual>
        <RowBlockWritingOffCommissionAccident v-else-if="showRowBlockWritingOffCommissionAccident(item)" :item="item" ></RowBlockWritingOffCommissionAccident>
        <RowBlockWritingOffCommissionGreenCard v-else-if="showRowBlockWritingOffCommissionGreenCard(item)" :item="item" ></RowBlockWritingOffCommissionGreenCard>
        <RowBlockWritingOffCommissionTourism v-else-if="showRowBlockWritingOffCommissionTourism(item)" :item="item" ></RowBlockWritingOffCommissionTourism>
        <RowBlockWritingOffCommissionMiniKasko v-else-if="showRowBlockWritingOffCommissionMiniKasko(item)" :item="item" ></RowBlockWritingOffCommissionMiniKasko>
        <RowBlockWritingOffCommissionPets v-else-if="showRowBlockWritingOffCommissionPets(item)" :item="item" ></RowBlockWritingOffCommissionPets>
        <RowBlockWritingOffReferralCommission v-else-if="showRowBlockWritingOffReferralCommission(item)" :item="item" ></RowBlockWritingOffReferralCommission>
        <RowBlockWritingOffCommissionTestOsago v-else-if="showBlockWritingOffCommissionTestOsago(item)" :item="item" ></RowBlockWritingOffCommissionTestOsago>
        <RowBlockWritingOffCommissionTestDgo v-else-if="showBlockWritingOffCommissionTestDgo(item)" :item="item" ></RowBlockWritingOffCommissionTestDgo>
        <RowBlockRefundFundsTestContract v-else-if="showBlockRefundFundsTestContract(item)" :item="item" ></RowBlockRefundFundsTestContract>
        <RowBlockPurchaseInsuranceThroughPaymentSystem v-else-if="showPurchaseInsuranceThroughPaymentSystem(item)" :item="item" ></RowBlockPurchaseInsuranceThroughPaymentSystem>
        <RowBlockBuyingBusInsurance v-else-if="showBlockBuyingBusInsurance(item)" :item="item" ></RowBlockBuyingBusInsurance>
        <RowBlockRefundFundsThroughPaymentSystem v-else-if="showBlockRefundFundsThroughPaymentSystem(item)" :item="item" ></RowBlockRefundFundsThroughPaymentSystem>

        <RowBlockBuyingInsuranceAutolawyer v-if="showBlockBuyingInsuranceAutolawyer(item)" :item="item" ></RowBlockBuyingInsuranceAutolawyer>
        <RowBlockInsuranceCommissionAutolawyer v-if="showBlockInsuranceCommissionAutolawyer(item)" :item="item" ></RowBlockInsuranceCommissionAutolawyer>
        <RowBlockRefundFundsCanceledContractAutolawyer v-if="showBlockRefundFundsCanceledContractAutolawyer(item)" :item="item" ></RowBlockRefundFundsCanceledContractAutolawyer>

        <RowBlockRefundFundsTestContractDgo v-if="showBlockRefundFundsTestContractDgo(item)" :item="item" ></RowBlockRefundFundsTestContractDgo>
        <RowBlockInsuranceCommissionDgo v-if="showBlockInsuranceCommissionDgo(item)" :item="item" ></RowBlockInsuranceCommissionDgo>
        <RowBlockBuyingInsuranceDgo v-if="showBlockBuyingInsuranceDgo(item)" :item="item" ></RowBlockBuyingInsuranceDgo>
        <RowBlockRefundFundsCanceledContractDgo v-if="showBlockRefundFundsCanceledContractDgo(item)" :item="item" ></RowBlockRefundFundsCanceledContractDgo>

        <RowBlockPaymentSystemCommissionLiqPay v-else-if="showBlockPaymentSystemCommissionLiqPay(item)" :item="item" ></RowBlockPaymentSystemCommissionLiqPay>
        <RowBlockPaymentSystemCommissioniPay v-else-if="showBlockPaymentSystemCommissioniPay(item)" :item="item" ></RowBlockPaymentSystemCommissioniPay>
        <RowBlockPaymentSystemCommissionHostPay v-else-if="showBlockPaymentSystemCommissionHostPay(item)" :item="item" ></RowBlockPaymentSystemCommissionHostPay>
        <RowBlockPaymentSystemCommissionPortmone v-else-if="showBlockPaymentSystemCommissionPortmone(item)" :item="item" ></RowBlockPaymentSystemCommissionPortmone>
        <RowBlockPromoCodeDiscount v-else-if="showBlockPromoCodeDiscount(item)" :item="item" ></RowBlockPromoCodeDiscount>
<!-- //TODO end -->
    </div>
</template>

<script>
    import RowBlockBuyingInsurance from './RowBlockBuyingInsurance.vue';
    import WritingOffComissionEarlyPolicyTermination from './WritingOffComissionEarlyPolicyTermination.vue';
    import WritingOffExcessComissionEarlyPolicyTermination from './WritingOffExcessComissionEarlyPolicyTermination.vue';
    import RefundOffComissionEarlyPolicyTermination from './RefundOffComissionEarlyPolicyTermination.vue';
    import RefundOfExcessComissionEarlyPolicyTermination from './RefundOfExcessComissionEarlyPolicyTermination.vue';
    import RowBlockInvoiceForClient from './RowBlockInvoiceForClient.vue';
    import RowBlockBuyingInsuranceDgo from './RowBlockBuyingInsuranceDgo.vue';
    import RowBlockBuyingInsuranceAutolawyer from './RowBlockBuyingInsuranceAutolawyer.vue';
    import RowBlockInsuranceCommission from './RowBlockInsuranceCommission.vue';
    import RowBlockInsuranceCommissionDgo from './RowBlockInsuranceCommissionDgo.vue';
    import RowBlockInsuranceCommissionAutolawyer from './RowBlockInsuranceCommissionAutolawyer';
    import RowBlockReferralInsuranceCommission from './RowBlockReferralInsuranceCommission.vue';
    import RowBlockInvoiceForClientByAdmin from './RowBlockInvoiceForClientByAdmin.vue';
    import RowBlockWritingOffCommissionDgo from './RowBlockWritingOffCommissionDgo.vue';
    import RowBlockWritingOffCommissionAutolawyer from './RowBlockWritingOffCommissionAutolawyer';
    import RowBlockRefundFundsTestContract from './RowBlockRefundFundsTestContract.vue';
    import RowBlockWritingOffCommissionOsago from './RowBlockWritingOffCommissionOsago.vue';
    import RowBlockWritingOffCommissionGreenCard from './RowBlockWritingOffCommissionGreenCard.vue';
    import RowBlockWritingOffCommissionAccident from "@/views/score/components/RowBlockWritingOffCommissionAccident.vue";
    import RowBlockWritingOffCommissionTourism from './RowBlockWritingOffCommissionTourism.vue';
    import RowBlockWritingOffCommissionMiniKasko from './RowBlockWritingOffCommissionMiniKasko.vue';
    import RowBlockWritingOffCommissionPets from './RowBlockWritingOffCommissionPets.vue';
    import RowBlockWritingOffReferralCommission from './RowBlockWritingOffReferralCommission';
    import RowBlockRefundFundsTestContractDgo from './RowBlockRefundFundsTestContractDgo.vue';
    import RowBlockWritingOffCommissionTestDgo from './RowBlockWritingOffCommissionTestDgo.vue';
    import RowBlockRefundFundsCanceledContract from './RowBlockRefundFundsCanceledContract.vue';
    import RowBlockRefundFundsCanceledContractDgo from './RowBlockRefundFundsCanceledContractDgo.vue';
    import RowBlockRefundFundsCanceledContractAutolawyer from './RowBlockRefundFundsCanceledContractAutolawyer';
    import RowBlockWritingOffCommissionTestOsago from './RowBlockWritingOffCommissionTestOsago.vue';
    import RowBlockPaymentInsuranceThroughInvoicing from './RowBlockPaymentInsuranceThroughInvoicing.vue';
    import RowBlockWithdrawInvoiceForClientByAdmin from './RowBlockWithdrawInvoiceForClientByAdmin.vue';
    import RowBlockPurchaseInsuranceThroughPaymentSystem from './RowBlockPurchaseInsuranceThroughPaymentSystem.vue';
    import RowBlockBuyingBusInsurance from './RowBlockBuyingBusInsurance.vue';
    import RowBlockBuyingGreenCardInsurance from './RowBlockBuyingGreenCardInsurance.vue';
    import RowBlockBuyingAccidentInsurance from './RowBlockBuyingAccidentInsurance.vue';
    import RowBlockBuyingTourismInsurance from './RowBlockBuyingTourismInsurance.vue';
    import RowBlockPaymentInsuranceByLegalEntity from "@/views/score/components/RowBlockPaymentInsuranceByLegalEntity.vue";
    import RowBlockPaymentMonobankPayParts from "@/views/score/components/RowBlockPaymentMonobankPayParts.vue";
    import RowBlockRefundFundsThroughPaymentSystem from "./RowBlockRefundFundsThroughPaymentSystem";
    import RowBlockBonusSystem from "@/views/score/components/RowBlockBonusSystem.vue";
    import RowBlockPaymentPenalty from "@/views/score/components/RowBlockPaymentPenalty.vue";
    import RowBlockBuyingManualInsurance from "@/views/score/components/RowBlockBuyingManualInsurance.vue";
    import RowBlockWritingOffCommissionManual from "@/views/score/components/RowBlockWritingOffCommissionManual.vue";
    import RowBlockInvoiceForPartnerByAdmin from "@/views/score/components/RowBlockInvoiceForPartnerByAdmin.vue";
    import RowBlockWithdrawInvoiceForPartnerByAdmin from './RowBlockWithdrawInvoiceForPartnerByAdmin.vue';
    import RowBlockWithdrawInvoiceForPartnerByMainUser from './RowBlockWithdrawInvoiceForPartnerByMainUser.vue';
    import RowBlockBuyingHomeInsurance from "@/views/score/components/RowBlockBuyingHomeInsurance.vue";
    import RowBlockBuyingPetsInsurance from "@/views/score/components/RowBlockBuyingPetsInsurance.vue";
    import RowBlockWithdrawalOfFunds from "@/views/score/components/RowBlockWithdrawalOfFunds.vue";
    import RowBlockPaymentSystemCommissionLiqPay from "@/views/score/components/RowBlockPaymentSystemCommissionLiqPay.vue";
    import RowBlockPaymentSystemCommissioniPay from "@/views/score/components/RowBlockPaymentSystemCommissioniPay.vue";
    import RowBlockPaymentSystemCommissionHostPay from "@/views/score/components/RowBlockPaymentSystemCommissionHostPay.vue";
    import RowBlockPaymentSystemCommissionPortmone from "@/views/score/components/RowBlockPaymentSystemCommissionPortmone.vue";
    import RowBlockPromoCodeDiscount from "@/views/score/components/RowBlockPromoCodeDiscount.vue";

    export default {
        components: {
            RowBlockPaymentSystemCommissionPortmone,
            RowBlockPaymentSystemCommissionHostPay,
            RowBlockPromoCodeDiscount,
            RowBlockPaymentSystemCommissioniPay,
            RowBlockPaymentSystemCommissionLiqPay,
            RowBlockBuyingHomeInsurance,
            RowBlockBuyingPetsInsurance,
            RowBlockInvoiceForPartnerByAdmin,
            RowBlockWritingOffCommissionManual,
            RowBlockBuyingManualInsurance,
            RowBlockPaymentPenalty,
            RowBlockBonusSystem,
            RowBlockBuyingInsurance,
            WritingOffComissionEarlyPolicyTermination,
            WritingOffExcessComissionEarlyPolicyTermination,
            RefundOffComissionEarlyPolicyTermination,
            RefundOfExcessComissionEarlyPolicyTermination,
            RowBlockInvoiceForClient,
            RowBlockBuyingInsuranceDgo,
            RowBlockBuyingInsuranceAutolawyer,
            RowBlockInsuranceCommission,
            RowBlockInsuranceCommissionDgo,
            RowBlockInsuranceCommissionAutolawyer,
            RowBlockReferralInsuranceCommission,
            RowBlockRefundFundsCanceledContractDgo,
            RowBlockRefundFundsCanceledContractAutolawyer,
            RowBlockInvoiceForClientByAdmin,
            RowBlockWritingOffCommissionDgo,
            RowBlockWritingOffCommissionAutolawyer,
            RowBlockRefundFundsTestContract,
            RowBlockWritingOffCommissionOsago,
            RowBlockWritingOffCommissionGreenCard,
            RowBlockWritingOffCommissionAccident,
            RowBlockWritingOffCommissionTourism,
            RowBlockWritingOffCommissionMiniKasko,
            RowBlockWritingOffCommissionPets,
            RowBlockWritingOffReferralCommission,
            RowBlockRefundFundsTestContractDgo,
            RowBlockWritingOffCommissionTestDgo,
            RowBlockRefundFundsCanceledContract,
            RowBlockWritingOffCommissionTestOsago,
            RowBlockWithdrawInvoiceForClientByAdmin,
            RowBlockWithdrawInvoiceForPartnerByAdmin,
            RowBlockPaymentInsuranceThroughInvoicing,
            RowBlockPurchaseInsuranceThroughPaymentSystem,
            RowBlockBuyingBusInsurance,
            RowBlockBuyingGreenCardInsurance,
            RowBlockBuyingAccidentInsurance,
            RowBlockBuyingTourismInsurance,
            RowBlockPaymentInsuranceByLegalEntity,
            RowBlockPaymentMonobankPayParts,
            RowBlockRefundFundsThroughPaymentSystem,
            RowBlockWithdrawalOfFunds,
            RowBlockWithdrawInvoiceForPartnerByMainUser,
        },
        props: {
            item: {
                type: Object,
                default: () => {
                    return {
                        transactionMainType: null,
                    };
                },
            },
        },
        computed: {
            accountCashHistoryInfo: function () {
                return this.$store.getters.ACCOUNT_CASH_HISTORY
            }
        },
        methods: {
            isPaymentPenalty: function (item) {
              return item.subtype === this.accountCashHistoryInfo.subtype['earnings_for_paying_a_fine'];
            },
            isInvoiceForClientByAdminType: function(item) {
                return item.subtype === this.accountCashHistoryInfo.subtype['create_invoice_for_client_by_admin']
            },
            isWithdrawInvoiceForClientByAdminType: function(item) {
                return item.subtype === this.accountCashHistoryInfo.subtype['create_withdraw_invoice_for_client_by_admin'];
            },
            isPaymentInsuranceThroughInvoicingType: function(item) {
                return item.subtype === this.accountCashHistoryInfo.subtype['payment_of_insurance_through_invoicing'];
            },
            isPaymentInsuranceByLegalEntityType: function(item) {
                return item.subtype === this.accountCashHistoryInfo.subtype['payment_of_insurance_by_legal_entity'];
            },
            isInvoiceForClientType: function(item) {
                return (item.subtype === this.accountCashHistoryInfo.subtype['create_invoice_for_client'] || item.subtype === this.accountCashHistoryInfo.subtype['create_invoice_for_partner_by_main_user'] || item.subtype === this.accountCashHistoryInfo.subtype['create_invoice_for_main_user_by_partner']);
            },
            isRefundFundsTestContract: function(item) {
                return item.subtype === this.accountCashHistoryInfo.subtype['refund_of_funds_for_test_contract'];
            },
            isRefundFundsTestContractDgo: function(item) {
                return item.subtype === this.accountCashHistoryInfo.subtype['refund_of_funds_for_test_contract'] &&
                       item.existDgo;
            },
            isWritingOffCommissionTestDgo: function(item) {
                return item.subtype === this.accountCashHistoryInfo.subtype['writing_off_commission_for_test_contract_dgo'];
            },
            isWritingOffCommissionTestOsago: function(item) {
                return item.subtype === this.accountCashHistoryInfo.subtype['writing_off_commission_for_test_contract_osago'];
            },
            isInvoiceForPartnerByAdminType: function(item) {
                return item.subtype === this.accountCashHistoryInfo.subtype['create_invoice_for_partner_by_admin'];
            },
            isWithdrawInvoiceForPartnerByAdminType: function(item) {
                return item.subtype === this.accountCashHistoryInfo.subtype['create_withdraw_invoice_for_partner_by_admin'];
            },
            isWithdrawInvoiceForPartnerByMainUser: function(item) {
                return item.subtype === this.accountCashHistoryInfo.subtype['create_withdraw_invoice_for_partner_by_main_user'];
            },


            isReplenishmentType: function (item) {
                return item.transactionMainType === this.accountCashHistoryInfo.mainTypes['replenishment'];
            },
            isAccrualType: function (item) {
                return item.transactionMainType === this.accountCashHistoryInfo.mainTypes['accrual'];
            },
            isWriteOffType: function (item) {
                return item.transactionMainType === this.accountCashHistoryInfo.mainTypes['writeOff'];
            },
            isBuyingInsuranceDgoType: function (item) {
                return item.typeId === this.accountCashHistoryInfo.types['transaction'] &&
                       item.existDgo;
            },
            isBuyingInsuranceAutolawyerType: function (item) {
                return item.typeId === this.accountCashHistoryInfo.types['transaction'] &&
                    item.existAutolawyer;
            },
            isBuyingInsuranceType: function(item) {
                return item.typeId === this.accountCashHistoryInfo.types['transaction'] &&
                    item.subtype === this.accountCashHistoryInfo.subtype['purchase_insurance'];
            },
            isWritingOffComissionEarlyPolicyTermination: function(item) {
                return item.typeId === this.accountCashHistoryInfo.types['transaction'] &&
                    item.subtype === this.accountCashHistoryInfo.subtype['writing_off_comission_early_policy_termination'];
            },
            isWritingOffExcessComissionEarlyPolicyTermination: function(item) {
                return item.typeId === this.accountCashHistoryInfo.types['transaction'] &&
                    item.subtype === this.accountCashHistoryInfo.subtype['writing_off_excess_comission_early_policy_termination'];
            },
            isRefundOffComissionEarlyPolicyTermination: function(item) {
                return item.typeId === this.accountCashHistoryInfo.types['transaction'] &&
                    item.subtype === this.accountCashHistoryInfo.subtype['refund_of_comission_early_policy_termination'];
            },
            isRefundOfExcessComissionEarlyPolicyTermination: function(item) {
                return item.typeId === this.accountCashHistoryInfo.types['transaction'] &&
                    item.subtype === this.accountCashHistoryInfo.subtype['refund_of_excess_comission_early_policy_termination'];
            },
            isBuyingBusInsuranceType: function(item) {
                return item.typeId === this.accountCashHistoryInfo.types['transaction'] &&
                    item.subtype === this.accountCashHistoryInfo.subtype['purchase_bus_insurance'];
            },
            isBuyingGreenCardInsuranceType: function(item) {
                return item.typeId === this.accountCashHistoryInfo.types['transaction'] &&
                    item.subtype === this.accountCashHistoryInfo.subtype['purchase_green_card_insurance'];
            },
            isBuyingAccidentInsuranceType: function(item) {
                return item.typeId === this.accountCashHistoryInfo.types['transaction'] &&
                    item.subtype === this.accountCashHistoryInfo.subtype['purchase_accident_insurance'];
            },
            isBuyingManualInsuranceType: function(item) {
                return item.typeId === this.accountCashHistoryInfo.types['transaction'] &&
                    item.subtype === this.accountCashHistoryInfo.subtype['purchase_manual_insurance'];
            },
            isBuyingTourismInsuranceType: function(item) {
                return item.typeId === this.accountCashHistoryInfo.types['transaction'] &&
                    item.subtype === this.accountCashHistoryInfo.subtype['purchase_tourism_insurance'];
            },
            isBuyingHomeInsuranceType: function(item) {
                return item.typeId === this.accountCashHistoryInfo.types['transaction'] &&
                    item.subtype === this.accountCashHistoryInfo.subtype['purchase_home_insurance'];
            },
            isBuyingPetsInsuranceType: function(item) {
                return item.typeId === this.accountCashHistoryInfo.types['transaction'] &&
                    item.subtype === this.accountCashHistoryInfo.subtype['purchase_pets_insurance'];
            },
            isInsuranceCommissionType: function(item) {
                return item.typeId === this.accountCashHistoryInfo.types['transaction_bonus'];
            },
            isInsuranceCommissionDgoType: function(item) {
                return item.typeId === this.accountCashHistoryInfo.types['transaction_bonus'] &&
                    item.existDgo;
            },
            isInsuranceCommissionAutolawyerType: function(item) {
                return item.typeId === this.accountCashHistoryInfo.types['transaction_bonus'] &&
                    item.existAutolawyer;
            },
            isReferralInsuranceCommissionType: function(item) {
                return item.typeId === this.accountCashHistoryInfo.types['transaction_referral_bonus'];
            },
            isRefundFundsCanceledContract: function(item) {
                return  item.subtype === this.accountCashHistoryInfo.subtype['refund_of_funds_for_canceled_contract'];
            },
            isRefundFundsCanceledContractDgo: function(item) {
                return  item.subtype === this.accountCashHistoryInfo.subtype['refund_of_funds_for_canceled_contract'] && item.existDgo;
            },
            isRefundFundsCanceledContractAutolawyer: function(item) {
                return  item.subtype === this.accountCashHistoryInfo.subtype['refund_of_funds_for_canceled_contract'] && item.existAutolawyer;
            },
            isRefundFundsThroughPaymentSystem: function(item) {
                return  item.subtype === this.accountCashHistoryInfo.subtype['refund_of_funds_through_payment_system'];
            },
            isWritingOffCommissionOsago: function(item) {
                return  item.subtype === this.accountCashHistoryInfo.subtype['writing_off_commission_for_terminated_contract_osago'];
            },
            isWritingOffCommissionManual: function(item) {
                return  item.subtype === this.accountCashHistoryInfo.subtype['writing_off_commission_for_terminated_contract_manual'];
            },
            isWritingOffCommissionGreenCard: function(item) {
                return  item.subtype === this.accountCashHistoryInfo.subtype['writing_off_commission_for_terminated_green_card_insurance'];
            },
            isWritingOffCommissionAccident: function(item) {
                return  item.subtype === this.accountCashHistoryInfo.subtype['writing_off_commission_for_terminated_accident_insurance'];
            },
            isWritingOffCommissionTourism: function(item) {
                return  item.subtype === this.accountCashHistoryInfo.subtype['writing_off_commission_for_terminated_tourism_insurance'];
            },
            isWritingOffCommissionDgo: function(item) {
                return  item.subtype === this.accountCashHistoryInfo.subtype['writing_off_commission_for_terminated_contract_dgo'];
            },
            isWritingOffCommissionAutolawyer: function(item) {
                return  item.subtype === this.accountCashHistoryInfo.subtype['writing_off_commission_for_terminated_contract_autolawyer'];
            },
            isWritingOffCommissionMiniKasko: function(item) {
                return item.subtype === this.accountCashHistoryInfo.subtype['writing_off_commission_for_terminated_contract_mini_kasko'];
            },
            isWritingOffCommissionPets: function(item) {
                return item.subtype === this.accountCashHistoryInfo.subtype['writing_off_commission_for_terminated_pets_insurance'];
            },
            // Referral transactions
            isWritingOffReferralCommission: function(item) {
                return  item.subtype === this.accountCashHistoryInfo.subtype['writing_off_referral_commission_for_terminated_contract_osago']
                    || item.subtype === this.accountCashHistoryInfo.subtype['writing_off_referral_commission_for_terminated_contract_dgo']
                    || item.subtype === this.accountCashHistoryInfo.subtype['writing_off_referral_commission_for_terminated_contract_green_card_insurance']|| item.subtype === this.accountCashHistoryInfo.subtype['writing_off_referral_commission_for_terminated_contract_accident_insurance']
                    || item.subtype === this.accountCashHistoryInfo.subtype['writing_off_referral_commission_for_terminated_contract_tourism_insurance']
                    || item.subtype === this.accountCashHistoryInfo.subtype['writing_off_referral_commission_for_terminated_contract_home_insurance']
            },
            isPurchaseInsuranceThroughPaymentSystem: function(item) {
                return  item.subtype === this.accountCashHistoryInfo.subtype['purchase_insurance_through_payment_system'];
            },
            isPaymentSystemCommissionLiqPay: function(item) {
                return item.subtype === this.accountCashHistoryInfo.subtype['payment_system_commission_liqpay'];
            },
            isPaymentSystemCommissioniPay: function(item) {
                return item.subtype === this.accountCashHistoryInfo.subtype['payment_system_commission_ipay'];
            },
            isPaymentSystemCommissionHostPay: function(item) {
                return item.subtype === this.accountCashHistoryInfo.subtype['payment_system_commission_hostpay'];
            },
            isPaymentSystemCommissionPortmone: function(item) {
                return item.subtype === this.accountCashHistoryInfo.subtype['payment_system_commission_portmone'];
            },
            isPromoCodeDiscount: function(item) {
                return item.subtype === this.accountCashHistoryInfo.subtype['promo_code_discount'];
            },
            showBlockBuyingInsuranceDgo: function (item) {
                return this.isWriteOffType(item) && this.isBuyingInsuranceDgoType(item);

            },
            showBlockBuyingInsuranceAutolawyer: function (item) {
                return this.isWriteOffType(item) && this.isBuyingInsuranceAutolawyerType(item);
            },
            showBlockBuyingInsurance: function (item) {
                return this.isWriteOffType(item) && this.isBuyingInsuranceType(item);
            },
            showBlockWritingOffComissionEarlyPolicyTermination: function (item) {
                return this.isWriteOffType(item) && this.isWritingOffComissionEarlyPolicyTermination(item);
            },
            showBlockWritingOffExcessComissionEarlyPolicyTermination: function (item) {
                return this.isWriteOffType(item) && this.isWritingOffExcessComissionEarlyPolicyTermination(item);
            },
            showBlockRefundOffComissionEarlyPolicyTermination: function (item) {
                return this.isAccrualType(item) && this.isRefundOffComissionEarlyPolicyTermination(item);
            },
            showBlockRefundOfExcessComissionEarlyPolicyTermination: function (item) {
                return this.isAccrualType(item) && this.isRefundOfExcessComissionEarlyPolicyTermination(item);
            },
            showBlockBuyingBusInsurance: function (item) {
                return this.isWriteOffType(item) && this.isBuyingBusInsuranceType(item);
            },
            showBlockBuyingGreenCardInsurance: function (item) {
                return this.isWriteOffType(item) && this.isBuyingGreenCardInsuranceType(item);
            },
            showBlockBuyingAccidentInsurance: function (item) {
                return this.isWriteOffType(item) && this.isBuyingAccidentInsuranceType(item);
            },
            showBlockBuyingManualInsurance: function (item) {
                return this.isWriteOffType(item) && this.isBuyingManualInsuranceType(item);
            },
            showBlockBuyingTourismInsurance: function (item) {
                return this.isWriteOffType(item) && this.isBuyingTourismInsuranceType(item);
            },
            showBlockBuyingHomeInsurance: function (item) {
                return this.isWriteOffType(item) && this.isBuyingHomeInsuranceType(item);
            },
            showBlockBuyingPetsInsurance: function (item) {
                return this.isWriteOffType(item) && this.isBuyingPetsInsuranceType(item);
            },
            showPurchaseInsuranceThroughPaymentSystem: function (item) {
                return this.isAccrualType(item) && this.isPurchaseInsuranceThroughPaymentSystem(item);
            },
            showBlockInsuranceCommission: function (item) {
                return this.isAccrualType(item) && this.isInsuranceCommissionType(item);
            },
            showBlockInsuranceCommissionDgo: function (item) {
                return this.isAccrualType(item) && this.isInsuranceCommissionDgoType(item);
            },
            showBlockInsuranceCommissionAutolawyer: function (item) {
                return this.isAccrualType(item) && this.isInsuranceCommissionAutolawyerType(item);
            },
            // Referral for all products types
            showBlockReferralInsuranceCommission: function (item) {
                return this.isAccrualType(item) && this.isReferralInsuranceCommissionType(item);
            },
            showBlockInvoiceForClient: function (item) {
                return this.isReplenishmentType(item) && this.isInvoiceForClientType(item);
            },
            showBlockPaymentInsuranceThroughInvoicing: function (item) {
                return this.isReplenishmentType(item) && this.isPaymentInsuranceThroughInvoicingType(item);
            },
            showBlockInvoiceForClientByAdmin: function (item) {
                return this.isReplenishmentType(item) && this.isInvoiceForClientByAdminType(item);
            },
            showBlockWithdrawInvoiceForClientByAdmin: function(item) {
                return this.isReplenishmentType(item) && this.isWithdrawInvoiceForClientByAdminType(item);
            },
            showBlockRefundFundsCanceledContract: function (item) {
                return this.isAccrualType(item) && this.isRefundFundsCanceledContract(item);
            },
            showBlockRefundFundsCanceledContractDgo: function (item) {
                return this.isAccrualType(item) && this.isRefundFundsCanceledContractDgo(item);
            },
            showBlockRefundFundsCanceledContractAutolawyer: function (item) {
                return this.isAccrualType(item) && this.isRefundFundsCanceledContractAutolawyer(item);
            },
            showBlockRefundFundsThroughPaymentSystem: function (item) {
                return this.isAccrualType(item) && this.isRefundFundsThroughPaymentSystem(item);
            },
            showRowBlockWritingOffCommissionDgo: function (item) {
                return this.isWriteOffType(item) && this.isWritingOffCommissionDgo(item);
            },
            showRowBlockWritingOffCommissionAutolawyer: function (item) {
                return this.isWriteOffType(item) && this.isWritingOffCommissionAutolawyer(item);
            },
            showRowBlockWritingOffCommissionOsago: function (item) {
                return this.isWriteOffType(item) && this.isWritingOffCommissionOsago(item);
            },
            showRowBlockWritingOffCommissionManual: function (item) {
                return this.isWriteOffType(item) && this.isWritingOffCommissionManual(item);
            },
            showRowBlockWritingOffCommissionGreenCard: function (item) {
                return this.isWriteOffType(item) && this.isWritingOffCommissionGreenCard(item);
            },
            showRowBlockWritingOffCommissionAccident: function (item) {
                return this.isWriteOffType(item) && this.isWritingOffCommissionAccident(item);
            },
            showRowBlockWritingOffCommissionTourism: function (item) {
                return this.isWriteOffType(item) && this.isWritingOffCommissionTourism(item);
            },
            showRowBlockWritingOffCommissionMiniKasko: function (item) {
                return this.isWriteOffType(item) && this.isWritingOffCommissionMiniKasko(item);
            },
            showRowBlockWritingOffCommissionPets: function (item) {
                return this.isWriteOffType(item) && this.isWritingOffCommissionPets(item);
            },
            showRowBlockWritingOffReferralCommission: function (item) {
                return this.isWriteOffType(item) && this.isWritingOffReferralCommission(item)
            },
            showBlockWritingOffCommissionTestOsago: function (item) {
                return this.isWriteOffType(item) && this.isWritingOffCommissionTestOsago(item);
            },
            showBlockWritingOffCommissionTestDgo: function (item) {
                return this.isWriteOffType(item) && this.isWritingOffCommissionTestDgo(item)
            },
            showBlockRefundFundsTestContract: function (item) {
                return this.isAccrualType(item) && this.isRefundFundsTestContract(item);
            },
            showBlockRefundFundsTestContractDgo: function (item) {
                return this.isAccrualType(item) && this.isRefundFundsTestContractDgo(item);
            },
            showBlockPaymentInsuranceByLegalEntity: function (item) {
                return this.isReplenishmentType(item) && this.isPaymentInsuranceByLegalEntityType(item);
            },
            showBlockMonobankPayParts: function (item) {
                return this.isReplenishmentType(item) && item.subtype === this.accountCashHistoryInfo.subtype['payment_of_insurance_by_monobank_pay_parts'];
            },
            showBlockInvoiceForPartnerByAdmin: function (item) {
                return this.isReplenishmentType(item) && this.isInvoiceForPartnerByAdminType(item);
            },
            showBlockWithdrawInvoiceForPartnerByAdmin: function(item) {
                return this.isReplenishmentType(item) && this.isWithdrawInvoiceForPartnerByAdminType(item);
            },
            showBlockWithdrawInvoiceForPartnerByMainUser: function(item) {
                return this.isReplenishmentType(item) && this.isWithdrawInvoiceForPartnerByMainUser(item);
            },
            showBlockPaymentSystemCommissionLiqPay: function (item) {
                return this.isWriteOffType(item) && this.isPaymentSystemCommissionLiqPay(item);
            },
            showBlockPaymentSystemCommissionHostPay: function (item) {
                return this.isWriteOffType(item) && this.isPaymentSystemCommissionHostPay(item);
            },
            showBlockPaymentSystemCommissioniPay: function (item) {
                return this.isWriteOffType(item) && this.isPaymentSystemCommissioniPay(item);
            },
            showBlockPaymentSystemCommissionPortmone: function (item) {
                return this.isWriteOffType(item) && this.isPaymentSystemCommissionPortmone(item);
            },
            showBlockPromoCodeDiscount: function (item) {
                return this.isWriteOffType(item) && this.isPromoCodeDiscount(item);
            },
        }
    }
</script>
